import { render } from "./SliderDescription.vue?vue&type=template&id=4f6f3ca9&scoped=true"
import script from "./SliderDescription.vue?vue&type=script&lang=js"
export * from "./SliderDescription.vue?vue&type=script&lang=js"

import "./SliderDescription.vue?vue&type=style&index=0&id=4f6f3ca9&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6f3ca9"]])

export default __exports__